import customAxios from "../../utils/customAxios";
import {
  ON_GET_INVOICES,
  GET_INVOICES,
  INVOICE_ERROR,
  ON_GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL,
  ON_CHARGE_INVOICE,
  CHARGE_INVOICE_SUCCESS,
  CHARGE_INVOICE_ERROR,
  ON_UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
  GET_INVOICE_PERIODS,
} from "../types";

export const getInvoices = (queryParams) => async (dispatch) => {
  try {
    dispatch({ type: ON_GET_INVOICES });
    const queryString = new URLSearchParams(queryParams).toString();
    const res = await customAxios.get(`/api/admin/invoices?${queryString}`);
    dispatch({
      type: GET_INVOICES,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error?.response?.data?.message || "Failed to load invoices",
    });
  }
};

export const getInvoiceDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: ON_GET_INVOICE_DETAIL });
    const res = await customAxios.get(`/api/admin/invoices/${id}`);
    dispatch({
      type: GET_INVOICE_DETAIL,
      payload: res.data.data,
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error?.response?.data?.message || "Failed to load invoice",
    });
  }
};

export const chargeInvoice = (id) => async (dispatch) => {
  try {
    dispatch({ type: ON_CHARGE_INVOICE });
    await customAxios.post(`/api/admin/invoices/${id}/charge`);
    dispatch({ type: CHARGE_INVOICE_SUCCESS });
    dispatch(getInvoiceDetail(id));
  } catch (error) {
    dispatch({
      type: CHARGE_INVOICE_ERROR,
      payload: error?.response?.data?.message || "Failed to charge invoice",
    });
  }
};

export const getInvoicePeriods = (userId) => async (dispatch) => {
  try {
    const res = await customAxios.get(`/api/admin/invoices/account/${userId}/periods`);
    dispatch({ type: GET_INVOICE_PERIODS, payload: res.data.data });
  } catch (error) {
    // Non-critical: the period switcher just falls back to the current period.
    dispatch({ type: GET_INVOICE_PERIODS, payload: [] });
  }
};

export const updateInvoicePaymentStatus = (id, paymentStatus) => async (dispatch) => {
  try {
    dispatch({ type: ON_UPDATE_INVOICE_STATUS });
    const res = await customAxios.put(`/api/admin/invoices/${id}/payment-status`, {
      paymentStatus,
    });
    dispatch({ type: UPDATE_INVOICE_STATUS_SUCCESS, payload: res.data.data });
  } catch (error) {
    dispatch({
      type: UPDATE_INVOICE_STATUS_ERROR,
      payload: error?.response?.data?.message || "Failed to update payment status",
    });
  }
};
